import Papa from "papaparse";
import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Chip,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Slider,
  TextField,
} from "@mui/material";
import { set } from "lodash";
import ImageDriveSearcher from "../components/GoogleDrive/ImageDriveSearcher";

const GoFilterPage: React.FC = () => {
  return (
    <Container>
      <ImageDriveSearcher />
    </Container>
  );
};

export default GoFilterPage;
